import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

export interface OrgModel {
  errorMsg: string;
  data: Array<any>;
}
@Injectable()
export class TranferStudentService {
  constructor(private http: HttpClient) {}
  getOrganizationlist(data) {
    return this.http.get(`/api/internaltransferstudent/getOrgList`, {
      params: data,
      responseType: "json",
      observe: "response"
    });
  }
  getUsStateList() {
    return this.http.get(`/api/internaltransferstudent/getStateList`, {
      responseType: "json",
      observe: "response"
    });
  }
  getUsCityList(id) {
    return this.http.get(`/api/internaltransferstudent/getCityList`, {
      params: { stateId: id },
      responseType: "json",
      observe: "response"
    });
  }
  getRequestDetails(requestId) {
    return this.http.get(`/api/internalRequest/getPersonRequestForDisplay`, {
      params: { type: requestId },
      responseType: "json"
    });
  }
  updateNewOrg(data) {
    return this.http.put(`/api/internaltransferstudent/transferStudent`, data, {
      observe: "response"
    });
  }
  addAuditLog(data) {
    return this.http.post(`/api/internaltransferstudent/auditLog`, data, {
      observe: "response"
    });
  }
  getOrgId(mdmId) {
    return this.http.get<OrgModel>(
      "/api/internaltransferstudent/getMdmIdById",
      {
        params: {
          mdmId: mdmId
        },
        observe: "response"
      }
    );
  }

  /**
   * @returns Data for an organization givent it's mdm_id
   * @param data
   */
  getOrgByMdmId(mdmId: string) {
    return this.http.get(`/api/internaltransferstudent/getOrgByMdmId`, {
      params: { mdmId: mdmId },
      responseType: "json",
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/service/transfer-student.service.ts